"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionList = void 0;
var React = require("react");
var core_1 = require("@athena-portal/core");
var journey_services_1 = require("@athena-portal/journey-services");
var QuestionList = exports.QuestionList = /** @class */ (function (_super) {
    __extends(QuestionList, _super);
    function QuestionList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QuestionList.prototype.render = function () {
        var _this = this;
        var interaction = this.props.interaction;
        var renderedQuestions = null;
        if (this.props.questions) {
            renderedQuestions = this.props.questions.map(function (question) {
                if (question.interactionField) {
                    if (journey_services_1.ObjectManipulator.fetchFieldValue(question.interactionField, interaction) === null) {
                        journey_services_1.ObjectManipulator.setField(question.interactionField, interaction, undefined);
                    }
                }
                if (_this.isVisible(question)) {
                    var questionComponent = _this.journeyComponentsManager.fetchQuestionComponent(question.type);
                    if (questionComponent && questionComponent.component) {
                        return React.createElement(questionComponent.component, __assign(__assign({}, _this.props), { key: question.name, question: question }));
                    }
                }
                return null;
            });
        }
        return (React.createElement(React.Fragment, null, renderedQuestions));
    };
    QuestionList.prototype.isVisible = function (question) {
        return !question.displayCondition || (question.displayCondition !== undefined &&
            journey_services_1.ConditionEvaluator.evaluateCondition(this.props.journey.displayConditions, question.displayCondition, this.props.interaction));
    };
    __decorate([
        (0, core_1.lazyInject)(core_1.TypeDefs.JourneyComponentsManager),
        __metadata("design:type", Object)
    ], QuestionList.prototype, "journeyComponentsManager", void 0);
    return QuestionList;
}(React.Component));
//# sourceMappingURL=QuestionList.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/plugin-journey/dist/widgets/QuestionList.js
// module id = 439
// module chunks = 0